import { COLOR_VALUES } from "shared/config/colors";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import styled, { css } from "styled-components/macro";

export const TimeOffCard = styled(VStack)`
    box-sizing: border-box;
    gap: 8px;
    border: 1px solid ${COLOR_VALUES.Gray_6};
    border-radius: 4px;
    flex: 2 1 auto;
    max-width: 19.75rem;
    min-width: 9.38rem;

    ${(props) =>
        props.isSmallSize
            ? css`
                  padding: 12px 8px 16px 16px;
              `
            : css`
                  padding: 16px 8px 24px 16px;
              `}
`;

export const StyledTextLabel = styled(Text)`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const VStackWrapper = styled(VStack)`
    flex-grow: 1;
    max-width: 50%;
    padding-right: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const TotalWrapper = styled.div`
    flex-grow: 1;
`;

export const VerticalLine = styled.div`
    margin-right: 16px;
    border-left: 1px solid ${COLOR_VALUES.Gray_6};
`;
